import { useEffect, useState, useMemo } from 'react'

export const useRetained = () => {
  const [retained, setRetained] = useState(false)

  useEffect(() => {
    const reset = () => setRetained(false)

    window.addEventListener('blur', reset, { passive: true })
    document.addEventListener('visibilitychange', reset, { passive: true })

    return () => {
      window.removeEventListener('blur', reset)
      document.removeEventListener('visibilitychange', reset)
    }
  }, [])

  return useMemo(() => [retained, setRetained] as const, [retained])
}
